import logoPWhite from '../../images/logo/pd-logomark-white.png';
import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const MobileMenuHeader = ({ setIsOpen }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-pddarkblue h-28 p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <img alt="Pure Desire Ministries" src={logoPWhite} className="mx-4 my-2 h-14" />
        </div>
        <div className="align-items-end mr-2 flex">
          <span className="text-pdwhite mr-3 font-semibold">{t('Close')}</span>
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            className="bg-pdwhite text-pdwhite hover:bg-pdwhite/20 rounded-full p-2"
          >
            <span className="sr-only">Close menu</span>
            <XMarkIcon className="size-6 text-black" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className="px-4 pb-4"></div>
    </div>
  );
};
